import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import usePriceBoardEnabled from './usePriceBoardEnabled';

/* One editor per provider: where the Prices page is on, /provider/services
   goes to it; where it's off, /provider/prices goes back to Services.
   Waits for the answer rather than flashing the wrong page. */
export default function PricesGate({ want, children }) {
  const { user } = useContext(AuthContext);
  const on = usePriceBoardEnabled(user);
  if (on === undefined) return null;
  if (want === 'prices' && !on) return <Navigate to="/provider/services" replace />;
  if (want === 'services' && on) return <Navigate to="/provider/prices" replace />;
  return children;
}
